// src/pages/Order/components/CancelSaleModal.styles.ts
import styled from "styled-components";

export const Body = styled.div`
  padding: 6px 20px calc(20px + env(safe-area-inset-bottom));
  font-family: ${(p) => p.theme.tokens.font.family};
`;

export const IconBadge = styled.div`
  width: 56px;
  height: 56px;
  border-radius: 999px;
  background: #fbeae7;
  color: #c0392b;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 14px;
`;

export const Message = styled.div`
  font-size: 13.5px;
  color: ${(p) => p.theme.tokens.colors.muted};
  text-align: center;
  line-height: 1.4;
  margin-bottom: 16px;
`;

export const FieldLabel = styled.label`
  display: block;
`;

export const LabelText = styled.span`
  display: block;
  font-size: 12.5px;
  font-weight: 700;
  color: ${(p) => p.theme.tokens.colors.muted};
  margin-bottom: 6px;
`;

export const Textarea = styled.textarea`
  width: 100%;
  box-sizing: border-box;
  border: 1.5px solid ${(p) => p.theme.tokens.colors.inputBorder};
  border-radius: 13px;
  padding: 12px 14px;
  font-size: 14.5px;
  font-family: ${(p) => p.theme.tokens.font.family};
  font-weight: 600;
  color: ${(p) => p.theme.tokens.colors.ink};
  outline: none;
  background: ${(p) => p.theme.tokens.colors.inputBg};
  resize: vertical;
  min-height: 84px;

  &:focus {
    border-color: ${(p) => p.theme.tokens.colors.green};
  }
`;

export const Actions = styled.div`
  display: flex;
  gap: 11px;
  margin-top: 18px;
`;
